/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  import config from "../config/credentialLists.config.json";
  // import axios from "axios";
  
  import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
  import { GET_POLICY_LIST } from "../graphql";
  import { VApplication } from "../../../application";
  
  const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
  };
  
  import moment from "moment";
  import { toHeaderCase } from "js-convert-case";
  
  export interface IDownloadPolicyListsMethods extends IPluginMethodMap {
    getDownloadPolicyListsProps(args: any): Promise<any>;
  }
  
  export interface IGetProvisionalListProps {
    offset?: number;
    size?: number;
    where?: any;
  }

  const lookup = require("country-code-lookup");
  
  export class DownloadPolicyListsService implements IAgentPlugin {
    readonly methods: IDownloadPolicyListsMethods;
  
    constructor() {
      this.methods = {
        getDownloadPolicyListsProps: this.getProps.bind(this),
      };
    }
  
    async getProps(args: IGetCredentialIssuedListProps) {
      console.log(`args in service:`, args);
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");
      try {
        if (client) {
          const res = await client.query({
            query: GET_POLICY_LIST,
            variables: {
              input: {
                skip: args?.offset ?? 0,
                limit: args?.size ?? 1000,
                where: [
                  {
                    column: "type",
                    value: ["PROVISIONAL"],
                    op: "Equal",
                  },
                  {
                    column: "status",
                    value: ["PAYMENT_PENDING"],
                    op: "In",
                  },
                ],
                order: [
                  {
                    column: "purchasedAt",
                    direction: "DESC",
                  },
                ],
              },
            },
            fetchPolicy: "network-only",
          });
          if (res?.data) {
            let _rowData = this.formatTable(res?.data?.getListOfPolicies?.data);
            return {
              ...config,
              ultUsers: _rowData,
              isEmpty: res?.data?.getListOfPolicies?.data?.length <= 0,
            };
          }
        }
      } catch (err: any) {
        return {
          isEmpty: true,
        };
      }
  
      // return { ...(config || {}) };
    }
  
    private formatTable(tableData: any) {
      let _rowData =
        Array.isArray(tableData) &&
        tableData.map((item: any) => {
          return {
            rowData: item,
            id: item?.policyId,
            vid: item?.purchasedBy?.vuid,
            policyNo: item?.policyNumber,
            country:item?.countryToBeInsured && item?.countryToBeInsured.length === 2
          ? lookup.byIso(`${item?.countryToBeInsured}`)?.country
          : "-",
            name: `${toHeaderCase(item?.purchasedBy?.firstName ?? "")} ${toHeaderCase(item?.purchasedBy?.lastName ?? "")}`,
            email: item?.purchasedBy?.email,
            // image:item?.image,
            dateCreated: item?.purchasedAt
              ? moment(item?.purchasedAt).format("LLL")
              : "-",
            coverage: item?.coverage,
            premium: item?.premium,
            discount:(item?.discountedPremium && item?.discountedPremium !== item?.premium )? item?.discountedPremium : "NA" ,
            policyOption: `Policy Option ${item?.productDefination}`,
          };
        });
      return _rowData;
    }
  }
  